/**
 * extract Responses from Post
 */
function getRatingAndTransmissibleData(post, superParent, ratings, userRatings) {
  const numRatings = ratings[post.id] !== undefined ?
    parseInt(ratings[post.id], 10) :
    post.numRatings;

  return {
    groupId: superParent.groupId,
    superParentId: superParent.superParentId || superParent.id,
    numRatings: numRatings || undefined,
    hasRated: post.hasRated || Array.isArray(userRatings) && userRatings.includes(post.id.toString()),
  };
}

function restructureResponses(post, ratings, userRatings) {
  Object.assign(post, getRatingAndTransmissibleData(post, post, ratings, userRatings));

  const lastResponse = post.response;
  if (!!lastResponse) {
    Object.assign(lastResponse, getRatingAndTransmissibleData(lastResponse, post, ratings, userRatings));
  }

  if (!Array.isArray(post.responses)) {
    delete post.responses;
    return;
  }

  const responses = post.responses;
  [post, ...responses].forEach(p => Object.assign(
    p,
    { responses: [] },
    getRatingAndTransmissibleData(p, post, ratings, userRatings)
    ));
  const parents = { 0: { post, index: -1 } };

  responses.forEach((response, index) => {
    const indent = response.indent;
    const father = parents[indent - 1];

    for (let i = indent; !!parents[i]; i++) {
      const { post: p, index: ind } = parents[i];
      p.totalResponses = index - ind - 1;
      delete parents[i];
    }

    if (father) {
      father.post.responses.push(response);
      response.parent = father.post.id;
    }

    parents[indent] = { post: response, index };
  });


  for (let i = 0; !!parents[i]; i++) {
    const { post: p, index: ind } = parents[i];
    p.totalResponses = responses.length - ind - 1;
  }
}

export default () => next => action => {
  const posts = action && action.data && action.data.posts;
  const ratings = action && action.data && action.data.ratings || {};
  const userRatings = action && action.data && action.data.userRatings || {};

  if (!posts || action.bypassMiddleware) {
    return next(action);
  }

  posts.forEach(p => restructureResponses(p, ratings, userRatings));

  return next(action);
};



// WEBPACK FOOTER //
// ./~/virgo/src/middlewares/middlewareReStructureResponses.js